import { useRecoilValue } from "recoil";
import { insetState } from "../../../recoil/inset";
import {
  CertRouteButton,
  CertRouteButtonWrapper,
  CertRouteInput,
  CertSurveyBottomButton,
  CertTitle,
  CertWrapper,
} from "./styles/cert";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";

interface StepProps {
  certRoute: string | null;
  setCertRoute: (route: string | null) => void;
  onNext: () => void;
}

const StepCertRoute = ({ certRoute, setCertRoute, onNext }: StepProps) => {
  const inset = useRecoilValue(insetState);
  const [otherRoute, setOtherRoute] = useState<boolean>(false);

  const handleNext = () => {
    if (certRoute === null) {
      enqueueSnackbar("러너펍 방문 경로를 알려주세요!", {
        variant: "error",
      });
      return;
    }
    onNext();
  };

  return (
    <CertWrapper isApp={inset}>
      <CertTitle>
        러너펍 방문 경로가
        <br />
        궁금해요
      </CertTitle>
      <CertRouteButtonWrapper>
        <CertRouteButton
          isSelected={certRoute === "지나가다 봤어요"}
          onClick={() => {
            setCertRoute("지나가다 봤어요");
            setOtherRoute(false);
          }}
        >
          🚶 지나가다 봤어요
        </CertRouteButton>
        <CertRouteButton
          isSelected={certRoute === "지인 추천"}
          onClick={() => {
            setCertRoute("지인 추천");
            setOtherRoute(false);
          }}
        >
          👭 지인 추천
        </CertRouteButton>
        <CertRouteButton
          isSelected={certRoute === "인터넷 검색"}
          onClick={() => {
            setCertRoute("인터넷 검색");
            setOtherRoute(false);
          }}
        >
          🔍 인터넷 검색
        </CertRouteButton>
        <CertRouteButton
          isSelected={certRoute === "오픈채팅"}
          onClick={() => {
            setCertRoute("오픈채팅");
            setOtherRoute(false);
          }}
        >
          💬 오픈채팅
        </CertRouteButton>
        <CertRouteButton
          isSelected={certRoute === "유튜브"}
          onClick={() => {
            setCertRoute("유튜브");
            setOtherRoute(false);
          }}
        >
          🎥 유튜브
        </CertRouteButton>
        <CertRouteButton
          isSelected={otherRoute}
          onClick={() => {
            setOtherRoute(true);
            setCertRoute(null);
          }}
        >
          ✨ 기타 (직접입력)
        </CertRouteButton>
        {otherRoute && (
          <CertRouteInput
            type="text"
            placeholder="내용을 입력해주세요."
            value={certRoute || ""}
            onChange={(e) => setCertRoute(e.target.value)}
          />
        )}
        <CertRouteButton
          isSelected={certRoute === "아직 방문한 적 없어요"}
          onClick={() => {
            setCertRoute("아직 방문한 적 없어요");
            setOtherRoute(false);
          }}
        >
          아직 방문한 적 없어요
        </CertRouteButton>
      </CertRouteButtonWrapper>
      <CertSurveyBottomButton
        isSelected={certRoute !== null}
        onClick={() => handleNext()}
      >
        다음
      </CertSurveyBottomButton>
    </CertWrapper>
  );
};

export default StepCertRoute;
